import type { PropsWithChildren } from 'react';

import { Center, type CenterProps, chakra } from '@chakra-ui/react';
import { type DropzoneOptions, useDropzone } from 'react-dropzone';

export interface UploadDropZoneProps extends Omit<CenterProps, 'onDrop'> {
  onDrop?: (files: Array<File>) => void;
  dropZoneOptions?: DropzoneOptions;
}

export const UploadDropZone: React.FC<
  PropsWithChildren<UploadDropZoneProps>
> = ({ onDrop, dropZoneOptions, children, ...rest }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    noClick: false,
    disabled: dropZoneOptions?.disabled,
    ...dropZoneOptions,
  });

  const inputProps = getInputProps();
  const rootProps = getRootProps({ className: 'dropzone' });

  return (
    <Center
      padding="20px 16px 20px 16px"
      gap={3}
      minH={32}
      rounded="lg"
      border="1px dashed"
      borderColor="brand.100"
      bg={isDragActive ? 'brand.50' : 'brand.25'}
      flexDirection="column"
      {...rootProps}
      {...rest}
    >
      <chakra.input {...inputProps} />
      {children}
    </Center>
  );
};
